export default __webpack_public_path__ + "f72c3eda56c63e83fa65b0ddae267c18.svg";